"use client";
import {
  domainApi,
  hostingApi,
  pagesApi,
  serverApi,
  setCurr,
  setHamburgerState,
  staticApi,
  vpsPackagesApi
} from "@/store";
import { getFromLocale, setToLocale } from "@/utils";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useCallback, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { Button } from "../Global/Button";
import { ProfileDropDown } from "./ProfileDropDown";
import { cleanPhoneNumber } from "../Footer";
const flags = {
  az: <Image width={24} height={16} src="/images/az.png" alt="az" className="w-6 h-4 object-cover" />,
  en: <Image width={24} height={16} src="/images/usa.png" alt="en" className="w-6 h-4" />
}

export const HeaderBtnGroup = ({ mobile = false ,currency,lang,phone}) => {
  const t = useTranslations();
  const { isOpenHamburger } = useSelector((state) => state.common); 
  const { authToken, user } = useSelector((state) => state.auth);

  const router = useRouter();
  const dispatch = useDispatch();
  const pathName = usePathname();
  const access_token = authToken || null;
  const isPurchaseRoute = pathName.includes("/purchase");

  const languageItem = lang;
  const defaultLanguage = {
    value: languageItem == "en" ? "en" : "az",
    label: languageItem == "en" ? flags.en : flags.az,
  };
  const defaultValue = { value: "AZN", label: flags.az };
  const [language, setLanguage] = useState({
    value: languageItem == "en" ? "en" : "az",
    label: languageItem == "en" ? flags.en : flags.az,
  });

  const [selectedCurrency, setSelectedCurrency] = useState({
    value: currency == "USD" ? "USD" : "AZN",
    label: currency == "USD" ? "$" : "₼",
  });

  const options = [
    { value: "USD", label: "$" },
    { value: "AZN", label: "₼" },
  ];
  const optionsLanguage = [
    { value: "en", label: flags.en },
    { value: "az", label: flags.az },
  ];

  const cleanedPhoneNumber=cleanPhoneNumber(phone)

  const funcHandler = useCallback(
    async (name) => {
      if (name === "logout") {
        return await logout();
      }

      if (name === "sign_in") {
        router.push("/sign-in");
        return dispatch(setHamburgerState(false));
      }
      if (name === "/get-quote") {
        window.open(
          `https://api.whatsapp.com/send?phone=${cleanedPhoneNumber}&text=` +
          t("getQuoteText"),
          "_blank"
        );
      }
      if (name === "/user/balance") {
        router.push(
          `${process.env.DASHBOARD_URL
          }/dashboard?access_token=${getFromLocale()}&lang=${getFromLocale(
            "language"
          )}`
        );
      }
    },
    [dispatch, router]
  );
  const logout = () => {
    localStorage.removeItem('access_token');
    window.location.reload()
  };

  const authBtn = access_token
    ? {
      id: "log_out",
      width: "min-w-[70px]",
      text: t("goToDasboard"),
      name: "light_blue_btn",
      func: () => funcHandler("/user/balance"),
    }
    : {
      id: "sign_in",
      width: "min-w-[120px]",
      text: t("signInBtn"),
      name: "light_blue_btn",
      func: () => funcHandler("sign_in"),
    };

  const header_btns = [
    {
      id: "get_quote",
      width: "min-w-[152px]",
      text: t("getQuote"),
      name: "main_btn",
      func: () => funcHandler("/get-quote"),
    },
    authBtn,
  ];

  const customStyles = {
    control: (defaultStyles) => ({
      ...defaultStyles,
      backgroundColor: "white",
      padding: "0px",
      margin: 0,
      fontWeight: "bold",
      border: "none",
      cursor: "pointer",
      boxShadow: "none",
      fontSize: "16px",
      outline: "none",
      "&:hover": {
        border: "none",
      }
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0",
      fontSize: "22px",
    }),

    singleValue: (defaultStyles) => ({
      ...defaultStyles, color: "#300B60", fontSize: "22px", width: "20px"
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "#300B60" : "#300B60",
      backgroundColor: state.isSelected ? "#f1e8ff" : "white",
      border: "none",
      fontWeight: "bold",
      paddingLeft: "17px",
      fontSize: "16px",
      "line-height": "1rem",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#f1e8ff"
      }
    }),
  };

  function currencyHandler(e) {
    var x = e.value;
    if (x !== selectedCurrency.value) {
      setSelectedCurrency(e);
      dispatch(setCurr(x));
      setToLocale({ key: "currency", value: x });
      document.cookie = `NEXT_CURRENCY=${x}; path=/; max-age=${30 * 24 * 60 * 60
        }`;
      dispatch(setHamburgerState(false));
      window.location.reload();
    }
  }
  const changeLanguage = (selectedOption) => {
    
    setToLocale({ key: "language", value: selectedOption.value });
    setLanguage(selectedOption);
    document.cookie = `NEXT_LOCALE=${selectedOption.value}; path=/; max-age=${30 * 24 * 60 * 60
      }`;

    // batch(() => {
    //   dispatch(hostingApi.util.resetApiState());
    //   dispatch(serverApi.util.resetApiState());
    //   dispatch(vpsPackagesApi.util.resetApiState());
    //   dispatch(domainApi.util.resetApiState());
    //   dispatch(staticApi.util.resetApiState());
    //   dispatch(pagesApi.util.resetApiState());
    // });
    dispatch(setHamburgerState(false));
    window.location.reload();
    router.refresh(pathName);
  };
  return (
    <>
      {
        <>
          <div className="flex flex-row  items-center shrink-0 ml-5 xl:ml-0">
            <div className={`${mobile ? "mr-7" : "mx-1"}`}>
              <Select
                onChange={currencyHandler}
                value={selectedCurrency}
                options={options}
                components={{
                  IndicatorSeparator: () => null,
                }}
                styles={customStyles}
                isSearchable={false}
                defaultValue={defaultValue}
                isDisabled={isPurchaseRoute}
                instanceId={"SelectCurrency"}
              />
            </div>
            <div>
              <Select
                onChange={changeLanguage}
                options={optionsLanguage}
                value={language}
                styles={customStyles}
                isSearchable={false}
                components={{
                  IndicatorSeparator: () => null,
                }}
                defaultValue={defaultLanguage}
                instanceId={"selectLang"}
              />
            </div>
          </div>
          {/* <div className="flex items-center"> */}
          {header_btns.map(({ id, width, text, name, func }) => (
            <div
              key={id}
              className={`font-semibold leading-6 ${isOpenHamburger ? "my-5" : "my-0"
                } ${width} ${!mobile ? "hidden xl:block" : ''}`}
              onClick={id === "log_out" ? null : func}
            >
              {id === "log_out" ? (
                <>
                  <div className="hidden xl:block">
                    <ProfileDropDown {...{ name, text, func, user, logout }} />
                  </div>
                  <div className="xl:hidden block">
                    <Button {...{ name, text, func }} />
                  </div>
                  <div className="xl:hidden block mt-4">
                    <Button {...{ name, text: t("signOut"), func: logout }} />
                  </div>
                </>
              ) : (
                <div>
                  <Button {...{ name, text, func }} />
                </div>
              )}
            </div>
          ))}
        </>
      }
    </>
  );
};
